import React, { Component } from 'react'
import { connect } from 'react-redux';
import getImage from "../images";
import styles from '../styles/loyalty.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowCircleRight } from '@fortawesome/free-solid-svg-icons'

class Heading extends Component {
    render() {
        const { title, subTitle, button, actionTitle, action, themeColors } = this.props;
        return (
            <div className={`${styles['fr-heading-div']}`}>
                <div className={`heading-section`}>
                    <span className={`${styles['fr-heading-title']} heading-sub-title`} style={{ color: themeColors && themeColors.headingColor }}>{title}</span>
                    <span className={`${styles['fr-heading-sub-title']} heading-title`} style={{ color: themeColors && themeColors.headingColor }}>{subTitle}</span>
                </div>
                {button ?
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <button className={`${styles['fr-heading-btn']} header-button`} onClick={() => action()}>{actionTitle}</button>
                        <FontAwesomeIcon style={{ color: '#A2A4AC' }} icon={faArrowCircleRight} />
                    </div>
                    : null}
            </div>
        )
    }
}

const mapState = (state, ownprops) => {
    return {
        themeColors: state.theme.themeColors
    };
}

const mapDispatch = {
}

export default connect(mapState, mapDispatch)(Heading);